export default __webpack_public_path__ + "851531f31339cb0e90afb67560531b0b.svg";